import React, { Component } from 'react';
import { connect } from 'react-redux';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';

import Sticky from 'Components/Sticky';
import { PROVIDER, VIMS_MODULE_ID } from 'Constants/commonConstants';
import {
    GET_HOLISTICS,
    GET_COMPANY_DATA,
    GET_REPORT_EMBED,
    SAVE_USER_REPORT_UTILIZATION_EVENT
} from 'Constants/actionConstants';
import { getUser, getCompanyType } from 'Utils/storage';
import classnames from 'classnames';
import ActionLoader from 'Components/ActionLoader';

const providerReports = {
    'default': {
        '1': ['Tracking MIS', '8405e55ffbafeb26eb198714'],
        '5': ['Completed Trips', '2af99c6569290c9cb570a30f']
    }
};

class Holistics extends Component {
    constructor() {
        super();
        this.isProvider = getCompanyType() === PROVIDER;
        this.state = this.isProvider
            ? {
                activeTab: '1',
                embed_code: (providerReports['default'])['1'][1],
                token: ''
            }
            : {
                activeTab: '1',
                token: '',
                embedCode: '',
                isReportsLoading: true,
                isEmbedLoading: false,
                reports: []
            }
    }


    providerToggle = (activeTab, embed_code, reportName) => {
        this.setState({ activeTab, embed_code, token: '' }, () => {
            this.getToken();
        });
        this.handleOnClickForReport(reportName)
    }

    getToken = () => {
        const { dispatch } = this.props;
        dispatch({
            type: GET_HOLISTICS,
            data: {
                embed_code: this.state.embed_code
            }
        })
    }

    componentWillReceiveProps(nextProps){
        if(this.isProvider && nextProps.token !== this.state.token) {
            this.setState({ token : nextProps.token });
        }
    }

    /*** Seeker flow — dynamic via fetchcompanydata ***/

    getDaaiReports = () => {
        const { dispatch } = this.props;
        const user = getUser();
        const seekerCompanyId = user.company_id;
        this.setState({ isReportsLoading: true });
        dispatch({
            type: GET_COMPANY_DATA,
            isSeeker: true,
            params: {
                module: 'VIMS',
                module_id: VIMS_MODULE_ID,
                companyId: user.company_id,
                seekerCompanyId
            },
            onSuccess: (responseData) => {
                const reports = (responseData && responseData.reports) || [];
                this.setState({ isReportsLoading: false, reports }, () => {
                    if (reports.length > 0) {
                        this.toggle(reports[0].type, reports[0].name);
                    }
                });
            },
            onError: () => {
                this.setState({ isReportsLoading: false, reports: [] });
            }
        });
    }

    toggle = (activeTab, reportName) => {
        this.setState({ activeTab, token: '', embedCode: '' },() => {
            this.getReportEmbed(activeTab);
        });
        this.handleOnClickForReport(reportName)
    }

    getReportEmbed = (reportType) => {
        const { dispatch } = this.props;
        const user = getUser();
        this.setState({ isEmbedLoading: true });
        dispatch({
            type: GET_REPORT_EMBED,
            params: {
                companyId: user.company_id,
                branchId: user.branch_id,
                type: reportType
            },
            onSuccess: (responseData) => {
                this.setState({
                    isEmbedLoading: false,
                    token: (responseData && responseData.token) || '',
                    embedCode: (responseData && responseData.embed_code) || ''
                });
            },
            onError: () => {
                this.setState({ isEmbedLoading: false, token: '', embedCode: '' });
            }
        });
    }


    handleOnClickForReport = (report_name) => {
        const { dispatch } = this.props;
        dispatch({
            type: SAVE_USER_REPORT_UTILIZATION_EVENT,
            payload: {
                event_name: "on_click_of_report",
                report_name: report_name
            },
        });
    }

    renderProvider() {
        const { dataSubmitting } = this.props;
        const { token, activeTab } = this.state;
        const availableReports = providerReports['default'];
        return (
            <Sticky activeLink={'mis'}>
                {!dataSubmitting && <ActionLoader fixed={true}></ActionLoader>}
                <Nav tabs className={'flex'} style={{'border': '1px solid lightgrey'}}>
                    {
                        Object.keys(availableReports).map((key, index) => {
                            const reportName = availableReports[key][0];
                            const embedCode = availableReports[key][1];
                            return (
                                <NavItem key={`report-${key}`} style={{'borderRight': '1px solid lightgrey', 'textAlign': 'center'}}>
                                    <NavLink
                                        className={classnames('fBolder', { active: activeTab === key })}
                                        onClick={() => {
                                            this.providerToggle(key, embedCode, reportName)
                                        }}
                                    >
                                    {reportName}
                                    </NavLink>
                                </NavItem>
                            )
                        })
                    }
                </Nav>
                <TabContent activeTab={activeTab}>
                    {
                        token && Object.keys(availableReports).map((key, index) => {
                            const embedCode = availableReports[key][1];
                            return (
                                <TabPane key={`report-pane-${key}`} tabId={key}>
                                    <iframe
                                        src={`https://secure.holistics.io/embed/${embedCode}?_token=${token}`}
                                        style={{width: "100%", height: 600}}
                                        frameborder="0"
                                        title="Holistics"
                                        allowFullScreen
                                    >
                                    </iframe>
                                </TabPane>
                            )
                        })
                    }
                </TabContent>
            </Sticky>
        );
    }

    renderSeeker() {
        const { token, embedCode, isReportsLoading, isEmbedLoading, reports, activeTab } = this.state;
        return (
            <Sticky activeLink={'mis'}>
                {(isReportsLoading || isEmbedLoading) && <ActionLoader fixed={true}></ActionLoader>}
                <Nav tabs className={'flex'} style={{'border': '1px solid lightgrey'}}>
                    {!isReportsLoading && reports.length === 0 && <NavItem style={{'textAlign': 'center'}}><NavLink disabled>No reports available</NavLink></NavItem>}
                    {
                        reports.map((report) => (
                            <NavItem key={`report-${report.type}`} style={{'borderRight': '1px solid lightgrey', 'textAlign': 'center'}}>
                                <NavLink
                                    className={classnames('fBolder', { active: activeTab === report.type })}
                                    onClick={() => {
                                        this.toggle(report.type, report.name)
                                    }}
                                >
                                {report.name}
                                </NavLink>
                            </NavItem>
                        ))
                    }
                </Nav>
                <TabContent activeTab={activeTab}>
                    {
                        token && embedCode && reports.map((report) => (
                            <TabPane key={`report-pane-${report.type}`} tabId={report.type}>
                                <iframe
                                    src={`https://secure.holistics.io/embed/${embedCode}?_token=${token}`}
                                    style={{width: "100%", height: 600}}
                                    frameborder="0"
                                    title="Holistics"
                                    allowFullScreen
                                >
                                </iframe>
                            </TabPane>
                        ))
                    }
                </TabContent>
            </Sticky>
        );
    }

    render() {
        return this.isProvider ? this.renderProvider() : this.renderSeeker();
    }

    componentDidMount() {
        if (this.isProvider) {
            this.getToken();
            try {
                const availableReports = providerReports['default'];
                const keys = Object.keys(availableReports)
                this.handleOnClickForReport(availableReports[keys[0]][0])
            } catch (error) {

            }
        } else {
            this.getDaaiReports();
        }
    }
}

const mapStateToProps = ({trips}) => {
  return {
    token: trips.holistics.token,
    embedCode: trips.holistics.embedCode,
    dataSubmitting: trips.holistics.dataSubmitting
  }
};


export default connect(mapStateToProps)(Holistics);
